import {useFormik} from 'formik';
import * as Yup from 'yup';
import {EditBlockDTO, useBlockById} from '../../../entities';
import {AxiosError} from 'axios';
import {useSchemes} from '../../../shared';
import {useMemo} from 'react';

interface UseEditBlockFormProps {
  setOpen: (open: boolean) => void;
  blockId: string | null;
}

export const useEditBlockForm = ({setOpen, blockId}: UseEditBlockFormProps) => {
  const {getBlock, updateBlockMutation} = useBlockById(blockId || '');
  const {nameSchema} = useSchemes();

  const titleSchema = useMemo(
    () =>
      Yup.string().required('Заголовок блока обязателен').max(256, 'Заголовок блока не должен превышать 256 символов'),
    [],
  );

  const onSubmit = async (values: EditBlockDTO) => {
    const {name, title} = values;
    try {
      if (blockId) {
        await updateBlockMutation.mutateAsync({
          blockId,
          name,
          title,
        });
      }
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: getBlock.data?.name || '',
      title: getBlock.data?.title || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: nameSchema,
      title: titleSchema,
    }),
    onSubmit: onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isLoading: updateBlockMutation.isPending,
    submitError: updateBlockMutation.error
      ? (updateBlockMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
